import React, { useState } from "react";
import { PRODUCT_IMAGES } from "./products";

function ProductThumb({ product, size = "md" }) {
    const [failed, setFailed] = useState(false);
    const imageUrl = PRODUCT_IMAGES[product.id];
    const showImage = imageUrl && !failed;

    return (
        <div
            className={`dc-thumb ${size === "sm" ? "dc-thumb--sm" : "dc-thumb--md"}`}
            style={
                showImage
                    ? undefined
                    : {
                        background: `linear-gradient(135deg, oklch(0.78 0.08 ${product.hue}), oklch(0.55 0.12 ${product.hue}))`,
                    }
            }
            aria-hidden="true"
        >
            {showImage ? (
                <img
                    src={imageUrl}
                    alt={product.name}
                    className="dc-thumb-img"
                    loading="lazy"
                    onError={() => setFailed(true)}
                />
            ) : (
                <div className="dc-thumb-pattern" />
            )}
        </div>
    );
}

export default ProductThumb;